/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-23T16:11:31.633
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listChanneltag,
	listChanneltagInit,
	listChanneltagByAuthorizations,
	deleteChanneltag
	
} from '@api/rentmanage/Channeltag';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listChanneltag({
			state
		}) {
			return new Promise((resolve, reject) => {
				listChanneltag(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listChanneltagByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listChanneltagByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listChanneltagInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listChanneltagInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteChanneltag({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteChanneltag({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
